import {
  ChatMessage,
  ChatMessageReplyTypes,
  ChatMessageStatus,
  InternalMessageStatus,
} from '../../../models';

export const getNewSessionGreeting = (
  chatId: string,
  reply: string,
  lastMessageTime: string,
): ChatMessage => ({
  id: lastMessageTime || new Date().toISOString(),
  chatId,
  createdAt: new Date().toISOString(),
  isSuccessReply: true,
  internalStatus: InternalMessageStatus.resolved,
  status: ChatMessageStatus.Delivered,
  request: '',
  lang: null,
  reply,
  links: null,
  replyType: ChatMessageReplyTypes.SIMPLE,
});
